<template>
	<div>
		<h3 class="text-lg border-b-2 mb-2">{{ label }}</h3>
		<div class="flex items-start w-full gap-2 flex-wrap">
			<div v-for="item in items" :key="item.slug" class="flex gap-1 items-center">
				<input @change="() => {}" type="radio" :id="item.slug" :name="item.type" :checked="modelValue.includes(item.slug)" class="hidden" />
				<label
					:for="item.slug"
					class="p-2 border-2 rounded-md cursor-pointer text-slate-500"
					:class="modelValue.includes(item.slug) ? 'bg-slate-500 text-white border-slate-500 shadow-md transition' : ''"
					@click="toggleItem(item)">
					{{ item.name }}
				</label>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, watch } from 'vue';

	const props = defineProps({
		items: {
			type: Array,
			default: () => [],
		},
		label: {
			type: String,
			default: '',
		},
		modelValue: {
			type: Array,
			default: () => [],
		},
	});

	const emit = defineEmits(['update:modelValue']);

	const toggleItem = (item) => {
		const newValue = [...props.modelValue];
		if (newValue[0] === item.slug) {
			newValue.splice(0, 1);
		} else {
			newValue.splice(0, 1);
			newValue.push(item.slug);
		}
		emit('update:modelValue', newValue);
	};
</script>
